import { _COLORS } from "../../../utils/constants";

// rows in payrol table
export const PAYROLL_ROWS = [
  { rowName: "Basic", key: "basic" },
  { rowName: "Overtime", key: "overtime" },
  { rowName: "EOY Bonus", key: "eoyBonus" },
  { rowName: "Merit Bonus", key: "meritBonus" },
  { rowName: "Production Bonus", key: "productionBonus" },
  { rowName: "Other Allow", key: "otherAllow" },
  {
    rowName: "Labour Cost",
    key: "labourCost",
    aggregatorOf: [
      "basic",
      "overtime",
      "eoyBonus",
      "meritBonus",
      "productionBonus",
      "otherAllow",
    ],
  },
  { rowName: "Meal Allowance", key: "mealAllowance" },
  { rowName: "Medical Expense", key: "medicalExpense" },
  { rowName: "NPS/EWF/IVTB", key: "npsEwfIvtb" },
  { rowName: "Travelling", key: "travelling" },

  {
    rowName: "Total",
    key: "grandTotal",
    aggregatorOf: [
      "labourCost",
      "mealAllowance",
      "medicalExpense",
      "npsEwfIvtb",
      "travelling",
    ],
  },
].map((def) => ({
  ...def,
  isAggregator: Array.isArray(def.aggregatorOf) && def.aggregatorOf.length > 0,
}));

export const defaultColDef = {
  cellClassRules: {
    "total-row": (params) => {
      return params.data.isAggregator && params.colDef.field !== "total";
    },
    "total-header-col": (params) => {
      return params.colDef.field === "total";
    },
  },
};

export const excelStylesPayroll = [
  {
    id: "month-header",
    interior: {
      color: _COLORS.headerAgGrid,
      pattern: "Solid",
    },
  },
  {
    id: "total-header-col",
    interior: {
      color: _COLORS.totalAgGrid,
      pattern: "Solid",
      font: {
        bold: true,
      },
    },
  },
  {
    id: "total-row",
    interior: {
      color: "#90EE90",
      pattern: "Solid",
    },
    font: {
      bold: true,
    },
  },
];

/**
 * @param {Array} allRows data from backend
 * @param {Array} rowDefs row definitions
 * @return {Object} { key -> row }
 */
function buildRowMap(allRows, rowDefs) {
  const rowMap = {};
  for (const row of allRows) {
    const def = rowDefs.find((fd) => fd.rowName === row.rowName);
    if (def) {
      rowMap[def.key] = row;
    }
  }
  return rowMap;
}

/**
 *
 * @param {Array} allRows
 * @param {Array} rowDefs
 */
function updateAggregatorRows(allRows, rowDefs) {
  const rowMap = buildRowMap(allRows, rowDefs);

  //row total column
  rowDefs.forEach((def) => {
    if (def.isAggregator && def.aggregatorOf) {
      const aggRow = rowMap[def.key];
      if (!aggRow) return;

      // pour chaque mois
      for (let m = 1; m <= 12; m++) {
        let sum = 0;
        // chaque groupe de lignes
        def.aggregatorOf.forEach((depKey) => {
          const depRow = rowMap[depKey];
          if (depRow) {
            sum += depRow[m] || 0;
          }
        });
        aggRow[m] = sum;
      }
    }
  });

  // right total column
  for (const row of allRows) {
    let s = 0;
    for (let m = 1; m <= 12; m++) {
      s += row[m] || 0;
    }
    row.total = s;
  }
}

/**
 *
 * @param {Array} inputPayrolls data from backend
 * @param {number} fiscalYear
 * @returns {Object}
 */
export function formDataToRow(inputPayrolls, fiscalYear) {
  const payrollMonthMap = {};

  // build a map of month -> payroll
  inputPayrolls.forEach((item) => {
    if (item.fiscalYear === fiscalYear) {
      const month = item.fiscalMonth;
      payrollMonthMap[month] = { ...item };
    }
  });

  // build rows
  const rows = PAYROLL_ROWS.map((fieldDef) => {
    const { rowName, key, isAggregator } = fieldDef;
    const rowData = {
      rowName,
      isAggregator,
      total: 0,
    };

    if (!isAggregator) {
      for (let m = 1; m <= 12; m++) {
        rowData[m] = payrollMonthMap[m]?.[key] ?? 0;
      }
    } else {
      for (let m = 1; m <= 12; m++) {
        rowData[m] = 0;
      }
    }

    return rowData;
  });

  updateAggregatorRows(rows, PAYROLL_ROWS);

  return { rows, payrollMonthMap };
}

/**
 *
 * @param {Array} allRows data from backend
 * @returns {Array}
 */
export function recalcAggregatorRows(allRows) {
  // clone the rows
  const newRows = [...allRows];

  updateAggregatorRows(newRows, PAYROLL_ROWS);

  return newRows;
}
